export default __webpack_public_path__ + "static/media/nyu-logo.163af7a8.webp";